import { request } from './request'
import transFormApi from './transform/index'
const baseURL = process.env.VUE_APP_BASEURL_BI
export const getBoard = (params) => {
  console.log('params', params)
  return request({
    method: 'get',
    url: baseURL + '/board/v1/get/board',
    params,
    headers: {
      token: true
    }
  })
}
export const getReports = (params) => {
  //4655
  return request({
    method: 'get',
    url: baseURL + '/report/v1/get/reports',
    params,
    headers: {
      token: true
    }
  })
}
export const getFolders = (params) => {
  return request({
    method: 'get',
    url: baseURL + '/folder/v2/get/dataBoards',
    params,
    headers: {
      token: true
    }
  })
}
// 复制看板
export const copyBoard = (params) => {
  return request({
    method: 'get',
    url: baseURL + '/folder/v2/copy/folders',
    params,
    headers: {
      token: true
    }
  })
}
// 另存报表
export const saveReportExtra = (data) => {
  return request({
    method: 'post',
    url: baseURL + '/report/v1/saveas/report',
    data,
    headers: {
      token: true
    }
  })
}

export async function updateBoardLayout({
  layoutData, boardID
}) {
  return request({
    method: 'POST',
    url: `${baseURL}/board/v1/update/board?boardID=${boardID}`,
    data: {
      otherParam: { layoutData }
    },
    headers: {
      token: true
    }

  })

}
export async function requestData(params) {
  return request({
    method: 'get',
    url: baseURL + '/report/v1/get/reports',
    params,
    headers: {
      token: true
    }
  })

}
// 删除报表
export async function deleteReport(params) {
  return request({
    method: 'get',
    url: baseURL + '/report/v1/delete/report',
    params,
    headers: {
      token: true
    }
  })

}
// 删除看板
export async function deleteBoard(params) {
  return request({
    method: 'get',
    url: baseURL + '/board/v1/delete/board',
    params,
    headers: {
      token: true
    }
  })

}
// 创建看板
export async function createBoard(params) {
  return request({
    method: 'get',
    url: baseURL + '/board/v1/create/board',
    params,
    headers: {
      token: true
    }
  })

}
// 编辑看板
export async function updateBoard(params) {
  return request({
    method: 'get',
    url: baseURL + '/board/v1/update/name',
    params,
    headers: {
      token: true
    }
  })

}
export async function queryV1Download(params, reportName, token, fn) {
  const requestOptions = {
    method: "post",
    url: baseURL + '/query/v1/download?reportName=' + reportName,
    data: params,
    withCredentials: false,
    responseType: "blob",
    headers: {
      responseType: "blob",
      token: true,
      "Content-Type": "application/json",
      Authorization: token,
      Accept: "application/octet-stream",
    },
  };
  return new Promise((resolve, reject) => {
    request(requestOptions).then(function (response) {
      if (response.status == 200) {
        var blob = new Blob([response.response.data], {
          type: 'application/vnd.ms-excel'
        });
        let url = window.URL.createObjectURL(blob);
        let link = document.createElement("a");
        link.style.display = "none";
        link.href = url;
        link.setAttribute("download", `${reportName}.xlsx`);
        document.body.appendChild(link);
        link.click();
        resolve(200);
      } else {
        reject(500);
      }
      if (fn) fn()
    });
  });
}
export async function downloadData(params, reportName, token, fn) {
  queryV1Download(params, reportName, token, fn);
}
export async function downloadDataDetail(
  params,
  reportName,
  token,
  back_url,
  reportId
) {
  return request({
    url: `${baseURL}/biApi/query/v3/download?reportName=${reportName}&reportId=${reportId}`,
    params: JSON.stringify(params),
    method: "post",
    headers: {
      token: true
    }
  });

}
export async function searchField(data) {
  return request({
    url: baseURL + "/query/v1/search",
    data,
    method: "post",
    headers: {
      token: true
    }
  });

}
// export async function queryData (data) {
//   return await request({
//     url: baseURL + "/query/v1",
//     data,
//     method: "post",
//     headers: {
//       token: true
//     }
//   });
// }
export async function queryData(data) {
  const dimLength = data.dimensions.length
  const numLength = data.measures.length
  const check = data.check
  let bodyData = transFormApi.setDirll(data)
  if (bodyData.linkConditions) {
    bodyData = transFormApi.setLink(bodyData)
  }

  const res = await request({
    url: baseURL + "/query/v1",
    data,
    method: "post",
    headers: {
      token: true
    }
  });
  if (res.status == 403 || res.status == 302) {
    return new Promise((resolve, reject) => {
      resolve({
        status: res.status,
        mes: 'token失效'
      })
    })
  }
  const returnData = transFormApi.formateDataToChart(res.result, dimLength, numLength)

  if (numLength && returnData.table.length && check) {
    let resSummary = res.result.totalResult
    const summaryData = {}
    try {
      data.dimensions.map((v) => {
        summaryData[v.chinese] = null
      })
      data.measures.map((v, i) => {
        summaryData[v.chinese] = resSummary[i]
      })
      Object.keys(summaryData).map((item, i) => {
        summaryData[item] = resSummary[i]
      })

      returnData.table.push({
        summaryData
      })
    } catch (e) {
      Error(e)
    }

  }



  return new Promise((resolve, reject) => {
    console.log('returnData', returnData, res)
    resolve({
      status: 200,
      result: returnData,
      columnMetas: res.result && res.result.columnMetas || [],
      last: res.result.last,
      sql: res.result.sql,
      tips: res.result.tips,
      wapFontList: res.wapFontList
    })
  })

}
export async function getModelList(params) {
  return request({
    url: baseURL + "/model/v1/models",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function getModelInfo(params) {
  return request({
    url: baseURL + "/model/v1/model/info",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function shareReport(params) {
  return request({
    url: baseURL + "/report/v1/share/report",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function saveReport(data) {
  return request({
    url: baseURL + "/report/v1/save/report",
    data,
    method: "post",
    headers: {
      token: true
    }
  });
}

export async function getReport(params) {
  return request({
    url: baseURL + "/report/v1/get/report",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function postTips(data) {
  return request({
    url: baseURL + "/warn/save/tips",
    data,
    method: "post",
    headers: {
      token: true
    }
  });
}
export async function deleteTips(params) {
  return request({
    url: baseURL + "/warn/delete/tips",
    params,
    method: "get",
    headers: {
      token: true
    }
  });

}


export async function updateBoardName(params) {
  return request({
    url: baseURL + "/board/v1/update/name",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
// 创建文件夹
export async function createFolder(params) {
  return request({
    url: baseURL + "/folder/v1/create/folder",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function deleteFolder(params) {
  return request({
    url: baseURL + "/folder/v1/delete/folder",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function updateFolder(params) {
  return request({
    url: baseURL + "/folder/v1/update/folder",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function getModelInfoList(params) {
  return request({
    url: baseURL + "/model/v2/modelConfigs",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function getModelConfigInfo(params) {
  return request({
    url: baseURL + "/model/v2/model/configInfo",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function deleteModel(params) {
  return request({
    url: baseURL + "/model/v1/remove/model",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}

export async function getModelsEnginTypes(params) {
  return request({
    url: baseURL + "/system/enginTypes",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function getModelsInfo(params) {
  return request({
    url: "/model/v1/model/info",
    params,
    method: "get",
    headers: {
      token: true
    }
  });
}
export async function postModelsInfoUpdate(data) {
  return request({
    url: baseURL + "/model/v2/model/update",
    data,
    method: "post",
    headers: {
      token: true
    }
  });
}
export async function postModelsInfoCreate(data) {
  return request({
    url: baseURL + "/model/v2/model/create",
    data,
    method: "post",
    headers: {
      token: true
    }
  });
}

// 获取看板列表
export const getBoardList = () => {
  return request({
    url: baseURL + "/board/v2/get/boardsV2",
    method: "get",
  });
}

// 创建看板
export const manageCerateBoard = (data) => {
  return request({
    url: baseURL + "/board/v2/create/board",
    method: "post",
    data,
    headers: {
      token: true
    }
  });
}

// 删除看板列
export const manageDeleteBoard = (boardId) => {
  return request({
    url: baseURL + `/board/v2/delete/board/${boardId}`,
    method: "delete",
  });
}

// 更新看板名称
export const manageUpdateBoard = (data) => {
  return request({
    url: baseURL + "/board/v2/update/name",
    method: "post",
    data,
    headers: {
      token: true
    }
  });
}

// 看板角色列表
export const getRoleList = (params) => {
  return request({
    url: baseURL + "/board/v2/list/roles",
    method: "post",
    params,
    headers: {
      token: true
    }
  });
}

// 设置权限
export const setRoleAuth = (data) => {
  return request({
    url: baseURL + "/board/v2/set/group",
    method: "post",
    data,
    headers: {
      token: true
    }
  });
}


// TODO:test-bi
export const testBi = (data) => {
  return request({
    method: 'get',
    url: baseURL + '/user/au',
    data,
    headers: {
      token: true
    }
  })
}
// 获取菜单列表
export const getMenuList = (data) => {
  return request({
    method: 'post',
    url: baseURL + '/folder/v2/page',
    data,
    headers: {
      token: true
    }
  })
}
// 新增或修改菜单和目录
export const addOrUpdateMenu = (data) => {
  return request({
    method: 'post',
    url: baseURL + '/folder/v2/addOrUpdate',
    data,
    headers: {
      token: true
    }
  })
}

// 删除菜单
export const removeMenu = (data) => {
  return request({
    method: 'delete',
    url: baseURL + `/folder/v2/delete/${data}`,
    headers: {
      token: true
    }
  })
}

// 设置菜单是否可见
export const showOrHideMenu = (data) => {
  return request({
    method: 'put',
    url: baseURL + `/folder/v2/setIsHide`,
    data,
    headers: {
      token: true
    }
  })
}

// 获取菜单列表
export const getMenu = (type) => {
  return request({
    method: 'get',
    url: baseURL + `/folder/v2/list/${type}`,
    headers: {
      token: true
    }
  })
}
// 获取平台看板
export const getDefaultBoard = (type) => {
  return request({
    method: 'get',
    url: baseURL + `/folder/v2/platform/board/${type}`,
    headers: {
      token: true
    }
  })
}

// 设置模型编辑状态
export async function setModelsEditStatus(data) {
  return request({
    url: baseURL + "/model/v2/model/update/editStatus",
    data,
    method: "post",
    headers: {
      token: true
    }
  });
}